// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__mVvOv","pageItem":"Pagination_pageItem__NtnyL","pageLink":"Pagination_pageLink__BJpZ5","pageItemActive":"Pagination_pageItemActive__PsRry"};